import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter as Router } from "react-router-dom"
import 'bootstrap/dist/css/bootstrap.min.css';
import "primereact/resources/themes/lara-light-cyan/theme.css";
import { TranslationProvider } from './contexts/TranslationContext';



const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Router>
    <TranslationProvider>
      <App />
     </TranslationProvider>
  </Router>
);


